import * as yup from 'yup';

export const createTikTokAdSchema = yup.object().shape({
  app: yup
    .string()
    .required('App is required')
    .trim()
    .min(1, 'App cannot be empty'),

  ad_account_id: yup
    .string()
    .required('Account ID is required')
    .trim()
    .min(1, 'Account ID cannot be empty'),

  campaign_templates: yup
    .array()
    .required('Campaigns templates are required')
    .min(1, 'At least one campaign template must be selected')
    .test('not-empty', 'Campaigns templates cannot be empty', (value) => {
      return value !== null && value !== undefined && value.length > 0;
    }),

  creative_packs: yup
    .array()
    .required('Creatives are required')
    .min(1, 'At least one creative must be selected')
    .of(yup.object().shape({
      tag: yup.string().default(''),
      creative_names: yup.array().of(yup.string().required()).required(),
    }))
    .test('valid-creatives', 'Each pack must contains creatives', (value) => {
      return value?.every(creative => creative.creative_names.length > 0) ?? false;
    }),

  ad_settings: yup
    .mixed()
    .required('Ad settings are required')
    .test('not-null', 'Ad settings cannot be null or undefined', (value) => {
      return value !== null && value !== undefined;
    }),
});

export type ValidatedCreateTikTokAdParams = yup.InferType<typeof createTikTokAdSchema>;